import { LineSectionsInterface } from '../lines/types';

/*
 * Action Types
 */
export enum FaresTypes {
  LIST_FARES_REQUEST = '@fares/LIST_FARES_REQUEST',
  LIST_FARES_SUCCESS = '@fares/LIST_FARES_SUCCESS',
  LIST_FARES_FAILURE = '@fares/LIST_FARES_FAILURE',

  LIST_CAR_FARES_REQUEST = '@fares/LIST_CAR_FARES_REQUEST',
  LIST_CAR_FARES_SUCCESS = '@fares/LIST_CAR_FARES_SUCCESS',
  LIST_CAR_FARES_FAILURE = '@fares/LIST_CAR_FARES_FAILURE',

  FILTER_FARES_REQUEST = '@fares/FILTER_FARES_REQUEST',
  FILTER_FARES_SUCCESS = '@fares/FILTER_FARES_SUCCESS',
  FILTER_FARES_FAILURE = '@fares/FILTER_FARES_FAILURE',

  GET_FARE_REQUEST = '@fares/GET_FARE_REQUEST',
  GET_FARE_SUCCESS = '@fares/GET_FARE_SUCCESS',
  GET_FARE_FAILURE = '@fares/GET_FARE_FAILURE',

  CREATE_FARE_REQUEST = '@fares/CREATE_FARE_REQUEST',
  CREATE_FARE_SUCCESS = '@fares/CREATE_FARE_SUCCESS',
  CREATE_FARE_FAILURE = '@fares/CREATE_FARE_FAILURE',

  CREATE_CAR_FARE_REQUEST = '@fares/CREATE_CAR_FARE_REQUEST',
  CREATE_CAR_FARE_SUCCESS = '@fares/CREATE_CAR_FARE_SUCCESS',
  CREATE_CAR_FARE_FAILURE = '@fares/CREATE_CAR_FARE_FAILURE',

  UPDATE_FARE_REQUEST = '@fares/UPDATE_FARE_REQUEST',
  UPDATE_FARE_SUCCESS = '@fares/UPDATE_FARE_SUCCESS',
  UPDATE_FARE_FAILURE = '@fares/UPDATE_FARE_FAILURE',

  UPDATE_CAR_FARE_REQUEST = '@fares/UPDATE_CAR_FARE_REQUEST',
  UPDATE_CAR_FARE_SUCCESS = '@fares/UPDATE_CAR_FARE_SUCCESS',
  UPDATE_CAR_FARE_FAILURE = '@fares/UPDATE_CAR_FARE_FAILURE',

  DELETE_FARE_REQUEST = '@fares/DELETE_FARE_REQUEST',
  DELETE_FARE_SUCCESS = '@fares/DELETE_FARE_SUCCESS',
  DELETE_FARE_FAILURE = '@fares/DELETE_FARE_FAILURE',

  DELETE_CAR_FARE_REQUEST = '@fares/DELETE_CAR_FARE_REQUEST',
  DELETE_CAR_FARE_SUCCESS = '@fares/DELETE_CAR_FARE_SUCCESS',
  DELETE_CAR_FARE_FAILURE = '@fares/DELETE_CAR_FARE_FAILURE',

  SET_CURRENT_OPERATION = '@fares/SET_CURRENT_OPERATION',
  SET_FARE_SELECTED = '@fares/SET_FARE_SELECTED',
}

/*
 * Data types
 */
export interface FareUpdateRequestInterface {
  id: string;
  fareId: string;
  data: string;
  createdAt: string;
  updatedAt: string;
  validFrom: string;
  description?: string;
  updated?: string;
}

export interface FareInterface {
  id: string;
  name: string;
  value: number;
  keepUntil?: string | null;
  previousValue?: string | null;
  FareUpdateRequest?: FareUpdateRequestInterface | null;
  FareUpdateRequests?: FareUpdateRequestInterface[];
  LineSections?: LineSectionsInterface[];
  subsidy: number;
  validFrom: string;
  description?: string;
  vehicleType?: string;
  externAvailable: boolean;
  otherValues: {
    name: string;
    type: string;
    value: number;
    label: string;
    checked: boolean;
    discount: string;
    operation: string;
  }[];
  transportOperatorId: string;
  createdAt?: string;
  updatedAt?: string;
}

export type OperationTypes = 'none' | 'create' | 'edit' | 'view';

/*
 * State type
 */
export interface FaresState {
  readonly faresList: FareInterface[];
  readonly carFaresList: FareInterface[];
  readonly fareData: FareInterface;
  readonly fareCreated: FareInterface;
  readonly fareSelected: FareInterface;
  readonly currentOperation: OperationTypes;
  readonly totalCount: number;
  readonly loading: boolean;
  readonly error: boolean;
}
